// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_coursesList__Co1JX {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.styles_courseItem__Oe255 {
  width: 100%;
  background: var(--color-white);
  padding: 4px;
  border-radius: 12px;
  transition: background-color 0.2s;
}

.styles_courseHeader__gI8Fg {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.styles_colorPickerContainer__BsdGm {
  position: relative;
}

.styles_colorButton__5InNY {
  width: 20px;
  height: 20px;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s;
  background: none;
  padding: 0;
  margin-left: 6px;
  margin-right: -4px;
}
.styles_colorButton__5InNY:hover {
  transform: scale(1.05);
}
.styles_colorButton__5InNY:active {
  transform: scale(0.95);
}

.styles_colorPalette__MN8zh {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding: 8px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 6px;
  z-index: 1000;
  min-width: 70px;
}

.styles_colorOption__gD\\+5u {
  width: 23px;
  height: 23px;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  padding: 0;
  background: none;
}
.styles_colorOption__gD\\+5u:hover {
  transform: scale(1.1);
  border-color: rgba(0, 0, 0, 0.2);
}
.styles_colorOption__gD\\+5u:active {
  transform: scale(0.95);
}

.styles_courseIcon__N63\\+b {
  width: 24px;
  height: 24px;
  color: var(--color-black);
  cursor: pointer;
}

.styles_courseTitle__3lXFe {
  font: var(--typography-label);
  color: var(--color-black);
  margin: 0;
  border: none;
  outline: none;
  background: transparent;
  width: 100%;
  text-align: left;
  padding: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/course-item/styles.module.scss"],"names":[],"mappings":"AACA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAAF;;AAGA;EACE,WAAA;EACA,8BAAA;EACA,YAAA;EACA,mBAAA;EACA,iCAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AAAF;;AAIA;EACE,kBAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EAEA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,0BAAA;EACA,gBAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;AAFF;AAIE;EACE,sBAAA;AAFJ;AAKE;EACE,sBAAA;AAHJ;;AAOA;EACE,kBAAA;EACA,qBAAA;EACA,OAAA;EACA,iBAAA;EACA,kBAAA;EACA,0CAAA;EACA,YAAA;EACA,aAAA;EACA,qCAAA;EACA,QAAA;EACA,aAAA;EACA,eAAA;AAJF;;AAOA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,UAAA;EACA,gBAAA;AAJF;AAME;EACE,qBAAA;EACA,gCAAA;AAJJ;AAOE;EACE,sBAAA;AALJ;;AASA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;AANF;;AASA;EACE,6BAAA;EACA,yBAAA;EACA,SAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;EACA,UAAA;AANF","sourcesContent":["@import \"mixins\";\n.coursesList {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.courseItem {\n  width: 100%;\n  background: var(--color-white);\n  padding: 4px;\n  border-radius: 12px;\n  transition: background-color 0.2s;\n}\n\n.courseHeader {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n// New styles for color picker\n.colorPickerContainer {\n  position: relative;\n}\n\n.colorButton {\n  width: 20px;\n  height: 20px;\n  border-radius: 4px;  // Add rounded corners\n  border: none;        // Remove all borders\n  //box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: transform 0.2s;\n  background: none;\n  padding: 0;\n  margin-left: 6px;\n  margin-right: -4px;\n\n  &:hover {\n    transform: scale(1.05);\n  }\n\n  &:active {\n    transform: scale(0.95);\n  }\n}\n\n.colorPalette {\n  position: absolute;\n  top: calc(100% + 8px);\n  left: 0;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  padding: 8px;\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 6px;\n  z-index: 1000;\n  min-width: 70px;\n}\n\n.colorOption {\n  width: 23px;\n  height: 23px;\n  border-radius: 4px;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s;\n  padding: 0;\n  background: none;\n\n  &:hover {\n    transform: scale(1.1);\n    border-color: rgba(0, 0, 0, 0.2);\n  }\n\n  &:active {\n    transform: scale(0.95);\n  }\n}\n\n.courseIcon {\n  width: 24px;\n  height: 24px;\n  color: var(--color-black);\n  cursor: pointer;\n}\n\n.courseTitle {\n  font: var(--typography-label);\n  color: var(--color-black);\n  margin: 0;\n  border: none;\n  outline: none;\n  background: transparent;\n  width: 100%;\n  text-align: left;\n  padding: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"coursesList": `styles_coursesList__Co1JX`,
	"courseItem": `styles_courseItem__Oe255`,
	"courseHeader": `styles_courseHeader__gI8Fg`,
	"colorPickerContainer": `styles_colorPickerContainer__BsdGm`,
	"colorButton": `styles_colorButton__5InNY`,
	"colorPalette": `styles_colorPalette__MN8zh`,
	"colorOption": `styles_colorOption__gD+5u`,
	"courseIcon": `styles_courseIcon__N63+b`,
	"courseTitle": `styles_courseTitle__3lXFe`
};
export default ___CSS_LOADER_EXPORT___;
